export default "__VITE_ASSET__YRZRCP$6__"